if (!window.Eurus.loadedScript.has('product-insurance.js')) {
  window.Eurus.loadedScript.add('product-insurance.js');

  const initInsuranceStore = () => {
    // Verhindern, dass der Store doppelt registriert wird
    if (Alpine.store('xPopupInsurance')) return;

    Alpine.store('xPopupInsurance', {
      open: false,
      loading: false,
      openInsuranceNoti: false,
      
      // Modal Logic
      showConfirmation: false,
      removalData: { key: null, line: null },

      openInsuranceNotification() {
        this.openInsuranceNoti = true;
        setTimeout(() => {
          this.openInsuranceNoti = false;
        }, 5000)
      },

      askConfirmation(key, line) {
        console.log("Versicherung entfernen angefragt", key, line); // Debugging
        this.removalData = { key, line };
        this.showConfirmation = true;
      },

      closeConfirmation() {
        this.showConfirmation = false;
        this.removalData = { key: null, line: null };
      }
    });
  };

  // Die entscheidende Änderung: Prüfen ob Alpine schon bereit ist
  if (window.Alpine) {
    initInsuranceStore();
  } else {
    document.addEventListener("alpine:init", initInsuranceStore);
  }
}